import React from 'react';
import PropTypes from 'prop-types';

const ToggleButton = ({
	buttons,
	activePrimaryButton,
	onClick,
	ButtonComponent,
	...restProps
}) => {
	const activeButton = buttons[+!activePrimaryButton];

	return <ButtonComponent {...restProps} {...activeButton} onClick={onClick} />;
};

ToggleButton.propTypes = {
	activePrimaryButton: PropTypes.bool,
	buttons: PropTypes.arrayOf(PropTypes.object).isRequired,
	ButtonComponent: PropTypes.elementType.isRequired,
	onClick: PropTypes.func
};

ToggleButton.defaultProps = {
	activePrimaryButton: true
};

export default ToggleButton;
